import { makeObservable, override } from 'mobx';
import {
    GetAgentLoan200Response,
    LoanApiFindAllLoansRequest,
    LoanDtoBrief,
} from 'src/generated-api-client';
import { bpmsResourcesManagerApi, loansApi } from 'src/services/apiServices';
import { ListFilter } from 'src/utils/FormHelper';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { BasicStoreApi } from 'src/utils/mobx/BasicStore/BasicStore.types';
import { FilterCriteria } from 'src/utils/mobx/FilterCriteria';
import { Pager } from 'src/utils/mobx/Pager';
import { Sorter } from 'src/utils/mobx/Sorter';
import { RequestHelper } from 'src/utils/RequestHelper';

export type LoansFilter = ListFilter<LoanApiFindAllLoansRequest>;

export class LoansStoreClass extends BasicStore<
    LoanDtoBrief,
    LoansFilter,
    unknown,
    unknown,
    GetAgentLoan200Response
> {
    constructor() {
        super();
        makeObservable(this);
    }

    itemPathKey = 'loanId';
    itemDetailsFormKey = 'embedded:deployment:forms/bo/bo-03-loan.json';

    pager = new Pager();
    sorter = new Sorter();
    filterCriteria = new FilterCriteria<LoansFilter>();

    api: BasicStoreApi<
        LoanDtoBrief,
        unknown,
        unknown,
        GetAgentLoan200Response
    > = {
        loadList: async (...args: any[]) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            const response = await RequestHelper.unwrapFromAxiosPromise(
                loansApi.findAllLoans(
                    {
                        ...this.pager,
                        ...this.sorter,
                        ...this.filterCriteria.filter,
                    },
                    options,
                ),
            );

            this.pager.setTotal(response.totalElements || 0);

            return response.content || [];
        },
        loadItem: (id: number, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                loansApi.getLoan({ id }, options),
            );
        },
        loadItemForm: (formKey: string, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                bpmsResourcesManagerApi.getForm({ formKey }, options),
            );
        },
    };

    @override get hasFilter() {
        return (
            Boolean(this.filterCriteria.filter.filterStatuses) ||
            (Boolean(this.filterCriteria.filter.filterIssueDateFrom) &&
                Boolean(this.filterCriteria.filter.filterIssueDateTo)) ||
            Boolean(this.filterCriteria.filter.filterSearch) ||
            Boolean(this.filterCriteria.filter.filterLoanTypes)
        );
    }
}

export const LoansStore = new LoansStoreClass();
